export default __webpack_public_path__ + "static/media/AdGhosts_06.d5832e64.png";